module.exports = __webpack_public_path__ + "static/img/qybj_01.3da84a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equity/qybj_01.jpg
// module id = HmK3
// module chunks = 0